export default __webpack_public_path__ + "static/media/profile.2b0a2ab8.jpg";